export default "__VITE_ASSET__DRCgF_eA__"